export default __webpack_public_path__ + "static/media/green_arrow.f07b1d6d.png";